import { DateTime } from 'luxon'
import moment from 'moment'

const Date = DateTime

export const frontEndDateFormat = (date, format = null) => {
  if (date) {
    if (format) {
      return Date.fromISO(date).toFormat(format)
    }
    return Date.fromISO(date).toLocaleString(Date.DATETIME_SHORT)
  }
  return ''
}

export const dateFromTimestamp = (date) => {
  if (date) {
    return moment.unix(date).format('MM/DD/YYYY')
  }
  return ''
}

export const dateDiff = (endDate, startDate = null) => {
  if (endDate) {
    let dateTo = Date.fromISO(endDate)
    let currentDate = startDate ? Date.fromISO(startDate) : Date.local()
    let difference = currentDate.diff(dateTo, 'milliseconds')
    difference = difference.values.milliseconds

    return difference
  }
  return ''
}

export const dateLeft = (millisec) => {
  if (millisec) {
    millisec = parseInt(millisec)
    let seconds = 0,
      minutes = 0,
      hours = 0,
      days = 0

    if (millisec < 0) {
      millisec = Math.abs(millisec)
      seconds = parseInt((millisec / 1000) % 60)
      minutes = parseInt((millisec / (1000 * 60)) % 60)
      hours = parseInt((millisec / (1000 * 60 * 60)) % 24)
      days = parseInt((millisec / (1000 * 60 * 60 * 24)) % 24)
    }

    return `${days}d ${hours}h ${minutes}min`
  }
  return ''
}

export const daysLeft = (date) => {
  if (date) {

    let millisec = parseInt(dateDiff(date))
    let days = 0

    if (millisec < 0) {
      millisec = Math.abs(millisec)
      days = parseInt(millisec / (1000 * 60 * 60 * 24))
    }

    return days
  }
  return ''
}
